<template>
  <div class="d-flex justify-content-between">
    <h1>Textbausteine</h1>

    <button class="btn" @click="loadTextbausteine()"><font-awesome-icon icon="rotate" /></button>
  </div>

  <div class="row mb-3">
    <div class="col-4">
      <router-link :to="{ name: 'EditTextbaustein' }" class="btn btn-primary"><font-awesome-icon icon="plus" /> Erstellen</router-link>
    </div>

    <div class="col-4">
      <div class="input-group input-group-sm my-auto">
        <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
        <span class="input-group-text">
          <font-awesome-icon icon="magnifying-glass" class="p-1" />
        </span>
      </div>
    </div>

    <div class="col-4 text-end">
      <div class="btn-group" role="group" aria-label="View Section select">
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'list' }" @click="setViewSection('list')">
          <font-awesome-icon icon="list" />
        </button>
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'grouped' }" @click="setViewSection('grouped')">
          <font-awesome-icon icon="layer-group" />
        </button>
      </div>
    </div>
  </div>

  <LoadingSpinner v-if="loading" text="... Textbausteine werden geladen ..." />

  <div v-else-if="errorMsg != ''" class="alert alert-danger mt-5">
    {{ errorMsg }}
    <!-- Es ist ein Fehler beim Laden der Vorlagen aufgetreten. Bite probieren Sie es später erneut. -->
  </div>

  <div v-if="textbausteine.length > 0" class="mt-2">
    <section v-if="viewSection == 'list'">
      <div class="row mx-0 mb-2 bg-white shadow-sm">
        <div class="col-4 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Baustein</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'nameasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'namedesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('nameasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'nameasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('namedesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'namedesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-4 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Überschrift</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'titelasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'titeldesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('titelasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titelasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('titeldesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titeldesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-2 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Gruppe</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'gruppeasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'gruppedesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('gruppeasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'gruppeasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('gruppedesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'gruppedesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-2 my-auto"><strong>Abschnitte</strong></div>
      </div>

      <TextbausteinRow v-for="textbaustein in sortedTextbausteine" :key="textbaustein.id" :textbaustein="textbaustein" />
    </section>

    <section v-else-if="viewSection == 'grouped'">
      <div v-for="(value, key) in groupedItems" :key="key" class="mb-4">
        <h4>{{ key }}</h4>

        <div class="row mx-0 mb-1">
          <div class="col-4 fw-bold px-2 my-auto">Baustein</div>
          <div class="col-4 fw-bold px-2 my-auto">Überschrift</div>
          <div class="col-2 fw-bold px-2 my-auto">Gruppe</div>
          <div class="col-2 fw-bold px-2 my-auto">Abschnitte</div>
        </div>

        <TextbausteinRow v-for="textbaustein in value" :key="textbaustein.id" :textbaustein="textbaustein" />
      </div>
    </section>
  </div>

  <div v-else-if="!loading && errorMsg == '' && textbausteine.length == 0" class="alert alert-info mt-5">Es wurden keine Textbausteine gefunden.</div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import TextbausteinRow from '@/components/Vorlagen/TextbausteinRow.vue';
  import { GroupedTextbausteine, Textbaustein } from '@/models/VorlageModels';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.getTextbausteineLoading);
  const errorMsg = computed(() => store.getters.status.textbausteinErrorMsg);

  const searchString = ref('');

  const sortByValue = ref('nameasc');
  function sortBy(param: string) {
    sortByValue.value = param;
  }

  const viewSection = ref('list');
  function setViewSection(section: string) {
    viewSection.value = section;
    sortByValue.value = 'gruppeasc';
    localStorage.setItem('textbausteineViewSection', section);
  }

  const textbausteine = computed(() => store.getters.textbausteine);
  const sortedTextbausteine = computed(() => {
    return textbausteine.value
      .filter((textbaustein: Textbaustein) => {
        return (
          textbaustein.name.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          textbaustein.titel.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          textbaustein.gruppe.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: Textbaustein, b: Textbaustein) => {
        if (sortByValue.value == 'nameasc' || sortByValue.value == 'namedesc') {
          var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
          if (sortByValue.value == 'namedesc') {
            nameComparison = -1 * nameComparison;
          }

          if (nameComparison == 0) {
            var titelComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
            return titelComparison;
          }

          return nameComparison;
        }

        if (sortByValue.value == 'titelasc' || sortByValue.value == 'titeldesc') {
          var titleComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
          if (sortByValue.value == 'titeldesc') {
            titleComparison = -1 * titleComparison;
          }

          if (titleComparison == 0) {
            var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
            return nameComparison;
          }

          return titleComparison;
        }

        if (sortByValue.value == 'gruppeasc' || sortByValue.value == 'gruppedesc') {
          var gruppeComparison = a.gruppe.trim().toLowerCase().localeCompare(b.gruppe.trim().toLowerCase());
          if (sortByValue.value == 'gruppedesc') {
            gruppeComparison = -1 * gruppeComparison;
          }

          if (gruppeComparison == 0) {
            var nameComparison = a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase());
            return nameComparison;
          }

          return gruppeComparison;
        }

        return 0;
      });
  });

  const groupedItems = computed<GroupedTextbausteine>(() => {
    const noGroup: Textbaustein[] = [];

    const data = sortedTextbausteine.value.reduce((groups: GroupedTextbausteine, textbaustein: Textbaustein) => {
      if (!textbaustein.gruppe) {
        noGroup.push(textbaustein);
      } else {
        const groupsList = textbaustein.gruppe.split(';');

        for (let group of groupsList) {
          group = group.trim();

          if (group === '') {
            continue;
          }

          const existingGroup = groups[group];

          if (existingGroup) {
            existingGroup.push(textbaustein);
          } else {
            groups[group] = [textbaustein];
          }
        }
      }
      return groups;
    }, {});

    // Sort keys alphabetically
    const sortedData: GroupedTextbausteine = {};
    Object.keys(data)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .forEach((key) => {
        sortedData[key] = data[key];
      });

    if (noGroup.length > 0) {
      sortedData['Keine Gruppe'] = noGroup;
    }

    return sortedData;
  });

  function loadTextbausteine() {
    store.dispatch(VorlageActionTypes.GetTextbausteine, undefined);
  }

  onMounted(() => {
    loadTextbausteine();

    viewSection.value = localStorage.getItem('textbausteineViewSection') || 'list';
  });
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
